<body class="my-login-page">
    <section class="h-100">
        <div class="container h-100">
            <ngx-spinner type="ball-beat"></ngx-spinner>

            <div class="row justify-content-md-center h-100">
                <div class="card-wrapper">
                    <div class="brand">
                        <!-- <img src="assets/logo_ipanema.png" alt="logo" style="background-color: #f7f9fb;"> -->
                        <img src="assets/logo_ipanema.png" alt="logo">
                    </div>
                    <div class="card fat">
                        <div class="card-body">
                            <h4 class="card-title">Login</h4>
                            <form [formGroup]="loginForm">
                                <div class="form-group">
                                    <label for="email">E-mail</label>
                                    <input id="email" type="email" class="form-control" formControlName="email" value=""
                                        required autofocus>
                                    <div *ngIf="submitted && f.email.errors" class="text-danger">
                                        Email inválido
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="password">Senha
                                        <a href="forgot.html" class="float-right">
                                            Esqueceu sua senha?
                                        </a>
                                    </label>
                                    <input id="password" type="password" class="form-control" formControlName="senha"
                                        required data-eye>
                                    <div *ngIf="submitted && f.senha.errors" class="text-danger">
                                        A senha é obrigatória
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="custom-checkbox custom-control">
                                        <input type="checkbox" formControlName="remember" id="remember"
                                            class="custom-control-input">
                                        <label for="remember" class="custom-control-label">Mantenha-me conectado</label>
                                    </div>
                                </div>

                                <div class="form-group m-0">
                                    <button type="submit" class="btn btn-primary btn-block" (click)="onSubmit()">
                                        Login
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="footer">
                        Copyright &copy; 2021 &mdash; <a target="_blank" href="https://www.primeinfor.com.br/">Prime
                            Automação</a>
                    </div>
                    
                    <div class="row mt-2">
                        <div class="col-sm text-center">
                            <div style="color:gray;">V. {{versao}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</body>